import React from "react"
import { StaticQuery, graphql } from "gatsby"
import {
  FaYelp,
  FaFacebookSquare,
  FaInstagram,
  FaTwitterSquare,
  FaPhoneSquare,
} from "react-icons/fa"

const SocialLinks = () => [
  <a
    key="facebook"
    rel="noopener noreferrer"
    aria-label="Facebook"
    target="_blank"
    href={`//facebook.com/GreaseMonkeyBurgers`}
  >
    <FaFacebookSquare alt="Facebook" />
  </a>,
  <a
    key="yelp"
    rel="noopener noreferrer"
    aria-label="Yelp"
    target="_blank"
    href={`//yelp.com/biz/the-grease-monkey-arlington`}
  >
    <FaYelp alt="Yelp" />
  </a>,
  <a
    key="instagram"
    rel="noopener noreferrer"
    aria-label="Instagram"
    target="_blank"
    href={`//instagram.com/greasemonkeyarlington`}
  >
    <FaInstagram alt="Instagram" />
  </a>,
  <a
    key="phone"
    rel="noopener noreferrer"
    aria-label="Place Call"
    href={`tel://817-665-5454`}
  >
    <FaPhoneSquare alt="Phone" />
  </a>,
]
export default SocialLinks
